(function () {

  'use strict';

  angular.module('Subscription')

    .constant('SUBSCRIPTION_TABS', [
      {
        icon: 'icon-invoice',
        section: 'billing',
        caption: 'Billing',
        selected: false,
        show: true
      },
      {
        icon: 'icon-credit-card',
        section: 'cardTransactions',
        caption: 'Transactions',
        selected: false,
        show: true
      },
      {
        icon: 'icon-history',
        section: 'history',
        caption: 'History',
        selected: false,
        show: true
      },
      {
        icon: 'icon-legal-docs',
        section: 'legalDocuments',
        caption: 'LegalDocuments',
        selected: false,
        show: true
      }
    ])

    .controller('SubscriptionController', function (
      $scope, $rootScope, TenantListService, $location, $http, $routeParams, EventServiceEvents,
      SUBSCRIPTION_TABS, EventHandlerService, currentTenant) {

      $scope.eventHandlerService = EventHandlerService;

      $scope.tabs = null;
      $scope.billingData = null;
      $scope.me = null;
      $scope.tenant = currentTenant;
      $scope.isPartnerTenant = false;

      (function () {
        $scope.tabs = checkIfPartnerTenant(SUBSCRIPTION_TABS);
        initEventHandler();
        getBillingData();
        evaluteRouteParam();
      })();

      $scope.$watch(() => {
        return $rootScope.currentUser;
      }, () => {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      function initEventHandler() {
        $scope.eventHandlerService.deRegisterListeners();
      };

      function checkIfPartnerTenant(SUBSCRIPTION_TABS) {
        if (currentTenant.info._links['px:salesPartner'] && currentTenant.info._links['px:servicePartner']) {
          SUBSCRIPTION_TABS.splice(0, 2);
          $scope.isPartnerTenant = true;
        }
        return SUBSCRIPTION_TABS;
      }

      function getBillingData() {
        const url = currentTenant.info._links['px:billingData'].href;
        $http.get(url)
          .then(function (response) {
            $scope.billingData = response.data;
          })
          .catch(function () {
          });
      }

      function evaluteRouteParam() {
        if ($routeParams.subscriptionSection) {
          $scope.showSection = $routeParams.subscriptionSection;
        } else {
          if ($scope.isPartnerTenant) {
            $scope.showSection = 'history';
          } else {
            $scope.showSection = 'billing';
          }
        }
      }

      $scope.setSection = function (section) {
        $scope.showSection = section;
        $scope.showCardInfo = false;
        const url = $location.path();
        $location.path(url, false).search({ subscriptionSection: section });
      };

      $scope.$watch(function () {
        return $scope.showSection;
      }, function () {
        if ($scope.showSection) {
          switch ($scope.showSection) {
            case 'billing':
              $scope.helpCaption = 'HelpSubscriptionBilling';
              break;
            case 'cardTransactions':
              $scope.helpCaption = 'HelpSubscriptionTransactions';
              break;
            case 'history':
              $scope.helpCaption = 'HelpSubscriptionInvoice';
              break;
            case 'legalDocuments':
              $scope.helpCaption = 'HelpSubscriptionLegalDocuments';
              break;
          }
        }
      }, true);

      const deregisterBillingDataUpdatedListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.BILLING_DATA_UPDATED, function (name, data) {
        TenantListService.currentTenant.refreshInfo()
          .then(function () {
            getBillingData();
          })
          .catch(function () {
          });
      });

      $scope.$on('$destroy', function () {
        deregisterBillingDataUpdatedListener();
      });

    });
})();
